<div mat-dialog-title>
  <span *ngIf="modalData.consultType === 'Intervention'">จอง intervention (โปรแกรม)</span>
  <span *ngIf="modalData.consultType === 'Consult'">จอง consult (ปรึกษา)</span>

  <div style="float: right; margin-top: -5px;">
    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>

<mat-dialog-content class="mat-typography">
  <div class="row" class="text-center">
    <h6 *ngIf="modalData.consultType === 'Intervention'" class="text-center">
      <b>Intervention (โปรแกรม) - {{ modalData.searchData }}</b>
    </h6>
    <h6 *ngIf="modalData.consultType === 'Consult'" class="text-center">
      <b>Consult (ปรึกษา) - {{ modalData.searchData }}</b>
    </h6>
  </div>
  <form [formGroup]="registerForm" class="mt-1">
    <div class="row">
      <label class="col-4 col-form-label"><b>หัวข้อ/รายละเอียด</b></label>
      <div class="col-8 col-form-label">
        {{ modalData.data.CONSULT_DETAIL.CONSULT_OBJECT !== '' ? modalData.data.CONSULT_DETAIL.CONSULT_OBJECT : '-' }}
      </div>
    </div>
    <div class="row">
      <div class="col-7">
        <div class="row">
          <label class="col-4 col-form-label"><b>วันที่</b></label>
          <div class="col-8 col-form-label">
            {{ modalData.data.CONSULT_DETAIL.CONSULT_DATE_START | date: 'full'}}
          </div>
        </div>
      </div>
      <div class="col-5">
        <div class="row">
          <label class="col-4 col-form-label"><b>ราคา</b></label>
          <div class="col-6 col-form-label" style="color: #DE5C8E">
            <span *ngIf="getPrice() > 0">
              {{ getPrice() | number }} บาท
            </span>
            <span *ngIf="getPrice() === 0">
              ฟรี
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <label class="col-4 col-form-label"><b>เวลา</b></label>
      <div class="col-6 col-form-label">
        {{ getTime(modalData.data.CONSULT_DETAIL.CONSULT_DATE_START, modalData.data.CONSULT_DETAIL.CONSULT_DATE_END) }}
      </div>
    </div>
    <div class="row">
      <label class="col-4 col-form-label"><b>อาจารย์</b></label>
      <span class="col-6 col-form-label">
        {{ modalData.consult.USERNAME }}
      </span>
    </div>
    <div class="row" *ngIf="modalData.consultType === 'Intervention'">
      <label class="col-4 col-form-label"><b>รูปแบบ</b></label>
      <div class="col-6 col-form-label">
        {{ modalData.data.CONSULT_DETAIL.CONSULT_TYPE }}
      </div>
    </div>

    <!-- เช็คว่ารอจ่ายเงิน หรือ รอยืนยันรึป่าว -->
    <div class="row">
      <label class="col-4 col-form-label"><b>รับคำปรึกษา</b></label>
      <div class="col-6 col-form-label">
        <mat-radio-group *ngIf="!waitPay && !waitConfirm && !payReject" formControlName="solution" disabled="true">
          <mat-radio-button value="on-site" style="margin-right: 15px;">On Site</mat-radio-button>
          <mat-radio-button value="zoom">Online</mat-radio-button>
        </mat-radio-group>

        <mat-radio-group *ngIf="waitPay || waitConfirm || payReject" formControlName="solution" disabled="true">
          <mat-radio-button value="on-site" style="margin-right: 15px;">On Site</mat-radio-button>
          <mat-radio-button value="zoom">Online</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div class="row">
      <label class="col-4 col-form-label"><b>ประเภทผู้เข้าร่วม</b></label>
      <div class="col-6 col-form-label">
        <!-- เช็คว่ารอจ่ายเงิน หรือ รอยืนยันรึป่าว -->
        <mat-radio-group *ngIf="!waitPay && !waitConfirm && !payReject" formControlName="joinType"
          (change)="clearJoinType()">
          <mat-radio-button value="คนเดียว" style="margin-right: 15px;">คนเดียว</mat-radio-button>
          <mat-radio-button value="หลายคน" (click)="goToScroll('countRegis')">หลายคน</mat-radio-button>
        </mat-radio-group>

        <mat-radio-group *ngIf="waitPay || waitConfirm || payReject" formControlName="joinType"
          (change)="clearJoinType()" disabled="true">
          <mat-radio-button value="คนเดียว" style="margin-right: 15px;">คนเดียว</mat-radio-button>
          <mat-radio-button value="หลายคน" (click)="goToScroll('countRegis')">หลายคน</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div class="row mb-2"
      *ngIf="registerForm.value.joinType === 'หลายคน' && modalData.data.CONSULT_DETAIL.CONSULT_TYPE === 'ร่วมกับผู้อื่น'">
      <label class="col-4 col-form-label">
        <b>จำนวนผู้เข้าร่วม</b>
      </label>
      <div class="col-6">
        <!-- เช็คว่ารอจ่ายเงิน หรือ รอยืนยันรึป่าว -->
        <input *ngIf="!waitPay && !waitConfirm && !payReject" id="countRegis" type="number" min="1" [max]="modalData.data.CONSULT_DETAIL.CONSULT_MAX -
        modalData.data.CONSULT_DETAIL.CONSULT_REGISTER" class="form-control" formControlName="countRegis"
          [ngModelOptions]="{standalone: true}">

        <input *ngIf="waitPay || waitConfirm || payReject" id="countRegis" type="number" min="1" [max]="modalData.data.CONSULT_DETAIL.CONSULT_MAX -
        modalData.data.CONSULT_DETAIL.CONSULT_REGISTER" class="form-control"
          [(ngModel)]="registerForm.value.countRegis" [ngModelOptions]="{standalone: true}" [attr.disabled]="true">

        <small class="text-danger">
          เข้าร่วมได้อีก {{ modalData.data.CONSULT_DETAIL.CONSULT_MAX -
          modalData.data.CONSULT_DETAIL.CONSULT_REGISTER | number}} คน
        </small>
      </div>
    </div>

    <div *ngIf="registerForm.value.joinType === 'หลายคน' && modalData.data.CONSULT_DETAIL.CONSULT_TYPE === 'ส่วนตัว'"
      class="row mb-2">
      <label class="col-4 col-form-label">
        <b>จำนวนผู้เข้าร่วม</b>
      </label>
      <div class="col-6">
        <!-- เช็คว่ารอจ่ายเงิน หรือ รอยืนยันรึป่าว -->
        <input *ngIf="!waitPay && !waitConfirm && !payReject" id="countRegis" type="number" min="1" class="form-control"
          formControlName="countRegis" [ngModelOptions]="{standalone: true}">
        <input *ngIf="waitPay || waitConfirm || payReject" id="countRegis" type="number" min="1" class="form-control"
          [(ngModel)]="registerForm.value.countRegis" [ngModelOptions]="{standalone: true}" [attr.disabled]="true">
      </div>
    </div>

    <div class="row mb-2">
      <label class="col-4 col-form-label">
        <b>เพิ่มเติม (ถ้ามี)</b>
      </label>
      <div class="col-8">
        <!-- เช็คว่ารอจ่ายเงิน หรือ รอยืนยันรึป่าว -->
        <textarea *ngIf="!waitPay && !waitConfirm && !payReject" id="moreDetail"
          [(ngModel)]="registerForm.value.moreDetail" class="form-control" rows="5"
          placeholder="เช่น เป็นโรคซึมเศร้า, ลูกสาวอายุ 3 ขวบ เป็นต้น" [ngModelOptions]="{standalone: true}"></textarea>
        <textarea *ngIf="waitPay || waitConfirm || payReject" id="moreDetail"
          [(ngModel)]="registerForm.value.moreDetail" class="form-control" rows="5"
          placeholder="เช่น เป็นโรคซึมเศร้า, ลูกสาวอายุ 3 ขวบ เป็นต้น" [ngModelOptions]="{standalone: true}"
          [attr.disabled]="true"></textarea>
      </div>
    </div>
  </form>
</mat-dialog-content>

<div align="center" class="pt-2 pb-3">
  <div *ngIf="!modalData.data.STATUS_PAY">
    <button mat-button *ngIf="registerForm.valid && !token" style="background: #3E8C1A; color: #fff;" routerLink="login"
      (click)="closeModal()">
      เข้าสู่ระบบ
    </button>
    <button mat-button *ngIf="registerForm.valid && token" style="background: #3E8C1A; color: #fff;"
      (click)="confirmRegister(registerForm.value, modalData)">
      {{ modalData.actionBtnText }}
    </button>
    <button mat-button *ngIf="!registerForm.valid && !token" [disabled]="!registerForm.valid">
      เข้าสู่ระบบ
    </button>
    <button mat-button *ngIf="!registerForm.valid && token" [disabled]="!registerForm.valid">
      {{ modalData.actionBtnText }}
    </button>
  </div>
  <div *ngIf="waitPay || waitConfirm || payReject">
    <button *ngIf="waitPay" mat-button style="background: #3E8C1A; color: #fff;" (click)="payment()">
      ชำระเงิน
    </button>
    <button *ngIf="payReject" mat-button style="background: #3E8C1A; color: #fff;" (click)="openHistory()">
      ชำระเงิน
    </button>
    <span *ngIf="waitConfirm" class="text-danger">
      รอการยืนยันธุรกรรม 2-3 วันทำการ
    </span>
  </div>
</div>
